import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Client from '@/model/entity/client/client';
import Techspec from '@/model/entity/job/techspec';
import TechspecDataTableReport from '@/model/service/job/report/techspec-data-table-report';
import TechspecDuplicateForm from '../techspec-duplicate-form/index.vue';

@Component({
    components: {
        'app-techspec-duplicate-form': TechspecDuplicateForm,
    },
})
export default class TechspecIndex extends Vue
{
    @Prop({
        type: Object,
        default: null,
    })
    private client!: Client;

    private duplicationDialog = false;
    private techspecToDuplicate: Techspec|null = null;

    $refs!:
    {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        dataTable: any,
    };

    protected report: TechspecDataTableReport|null = null;

    private created()
    {
        this.report = new TechspecDataTableReport(this.$serviceContainer, this.client);
    }

    @Watch('client')
    private onClientChanged()
    {
        if (!this.report)
        {
            return;
        }

        this.report.setClient(this.client);
        this.$refs.dataTable.reload();
    }

    /**
     * Handles duplication click events
     */

    private onDuplicateTechspec(techspec: Techspec)
    {
        this.techspecToDuplicate = techspec;
        this.duplicationDialog = true;
    }

    /**
     * Handles duplication cancellation
     */

    private onCancelDuplicateTechspec()
    {
        this.duplicationDialog = false;
        this.techspecToDuplicate = null;
    }

    /**
     * Handles duplications
     *
     * @param duplicateId
     */

    private onDuplicated(duplicateId: number)
    {
        this.duplicationDialog = false;

        this.$router.push({
            name: 'techspec-view',
            params: {
                id: duplicateId.toString(),
            },
        }).catch();
    }
}